var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronRightBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9337,
    cy: 17.6719,
    r: 16.3691,
    fill: "#3661FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0632 16.707C10.5109 16.707 10.0632 17.1547 10.0632 17.707C10.0632 18.2593 10.5109 18.707 11.0632 18.707V16.707ZM23.5802 18.4141C23.9707 18.0236 23.9707 17.3904 23.5802 16.9999L17.2162 10.636C16.8257 10.2454 16.1925 10.2454 15.802 10.636C15.4115 11.0265 15.4115 11.6597 15.802 12.0502L21.4589 17.707L15.802 23.3639C15.4115 23.7544 15.4115 24.3876 15.802 24.7781C16.1925 25.1686 16.8257 25.1686 17.2162 24.7781L23.5802 18.4141ZM11.0632 18.707H22.8731V16.707H11.0632V18.707Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBlue);
export default __webpack_public_path__ + "static/media/chevron-right-blue.d53a638f5a103e6e7a767f0e4156dca1.svg";
export { ForwardRef as ReactComponent };